<template>
  <div class="dovemed-container mt-0">
    <!-- <div class="up-header secondary-background">
      <div>
        <div class="signup-container">
          <div
            class="root"
            v-if="
              $route.query.role === 'patient' ||
                $route.query.role === 'caregiver'
            "
          >
            <div class="progressbar-container" v-if="onRoute">
              <ul class="progressbar">
                <li
                  id="progress_bar"
                  v-for="(item, i) in stepData"
                  :style="{ color: getPrimaryColor() }"
                  :key="i"
                  v-bind:class="{ active: i === activeLength - 1 }"
                >
                  <span class="p-circle"></span>
                  <span v-if="i > 0" class="p-bar "></span>
                  <p class="text">{{ item }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "UserProfileLayout",
  computed: {
    ...mapGetters({
      currentCircle: "Circle/currentCircle",
      userTypeSelect: "Signup/userTypeSelect"
    })
  },
  data() {
    return {
      onRoute: {},
      stepData: [
        "WELCOME",
        "SYMPTOMS",
        "TREATMENTS",
        "OTHER CONDITIONS",
        "YOUR STORY"
      ],
      activeLength: null
    };
  },

  mounted() {
    this.onRoute[
      `/${this.currentCircle.key_name}/signup/userProfile/welcome`
    ] = 1;
    this.onRoute[
      `/${this.currentCircle.key_name}/signup/userProfile/symptoms`
    ] = 2;
    this.onRoute[
      `/${this.currentCircle.key_name}/signup/userProfile/treatments`
    ] = 3;
    this.onRoute[
      `/${this.currentCircle.key_name}/signup/userProfile/other_symptoms`
    ] = 4;
    this.onRoute[
      `/${this.currentCircle.key_name}/signup/userProfile/yourStory`
    ] = 5;
    this.activeLength = this.onRoute[decodeURIComponent(this.$route.path)];

    window.scrollTo(0, 0);
  },

  updated() {
    // Fired every second, should always be true
    this.updateColor();
  },

  methods: {
    urlEncode(data) {
      return encodeURI(data);
    },

    updateColor() {
      this.$el.querySelectorAll("li").forEach((ele, i) => {
        if (ele.classList.contains("active")) {
          console.log(ele.children[0], typeof ele.children[0], "alsdmkjasbd");
          ele.children[0].setAttribute(
            "style",
            ` background: ${this.currentCircle.color_code} !important`
          );

          // ele.children[0].setAttribute("class", `progress-mobile `);

          // ele.children[0].setAttribute("style", );
          // if (ele.children.length > 1) {
          //   ele.children[1].setAttribute(
          //     "style",
          //     ` background: ${this.currentCircle.color_code} !important `
          //   );
          // }
        } else {
          if (!ele.classList.contains("active")) {
            if (ele.children[0].hasAttribute("style")) {
              ele.children[0].removeAttribute("style");

              // if (ele.children.length > 1) {
              //   ele.children[1].removeAttribute(
              //     "style",
              //     ` background: ${this.currentCircle.color_code} !important `
              //   );
              // }
            }
          }
        }
      });
    }
  },
  watch: {
    $route() {
      this.activeLength = this.onRoute[this.$route.path];
    }
  }
};
</script>

<style lang="scss" scoped>
.text {
  @media screen and (max-width: 900px) {
    display: none;
  }
  @media screen and (max-width: 600px) {
    display: none;
  }
}
.secondary-background {
  @media screen and (max-width: 900px) {
    background: none;
  }
}
.active {
  .p-circle {
    @media screen and (max-width: 900px) {
      width: 30px;
      border-radius: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/UserProfile/UserProfileLayout.vue